import { initialState } from '../initialState';

export const blogCategoryReducer = (state = initialState.blogCategoryReducer, action) => {
  switch (action.type) {
    case 'CHANGE_BLOG_CATEGORY':
      return {
        currentCategory:
          action.payload === state.blogCategoryReducer
            ? initialState.blogCategoryReducer.currentCategory
            : action.payload,
      };
    case 'RESET_BLOG_CATEGORY':
      return {
        ...initialState.blogCategoryReducer,
      };
    default:
      return state;
  }
};
